type SendTargetHelperVisibilityInput = {
  isEdited?: boolean;
  reviewType?: string;
  status?: string;
  defaultDateValue?: string | null;
  hasDateError: boolean;
};

const SPECIAL_DATE_VALUES = new Set(['N/A', 'TBD']);

const normalizeDateValue = (value?: string | null): string =>
  (value || '').toString().trim();

export const shouldShowSendTargetDefaultDateHelper = (
  input: SendTargetHelperVisibilityInput
): boolean => {
  const normalizedStatus = normalizeDateValue(input.status).toLowerCase();
  const normalizedReviewType = normalizeDateValue(input.reviewType);
  const defaultDateValue = normalizeDateValue(input.defaultDateValue);

  const isSendTargetStatus =
    normalizedReviewType === 'Async' &&
    (normalizedStatus === 'async_target' || normalizedStatus === 'target');

  const hasDefaultDate =
    Boolean(defaultDateValue) &&
    !SPECIAL_DATE_VALUES.has(defaultDateValue.toUpperCase());

  return (
    input.isEdited === false &&
    isSendTargetStatus &&
    hasDefaultDate &&
    !input.hasDateError
  );
};
